"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CookieStorageServer = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _api = require("@whitbread-eos/api");
var _cookies = _interopRequireDefault(require("cookies"));
var _base = require("../helpers/base64");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
class CookieStorageServer {
  constructor(req, res) {
    this.cookies = new _cookies.default(req, res);
  }
  setItem(key, value, additionalParams) {
    var _this = this;
    return (0, _asyncToGenerator2.default)(function* () {
      _this.cookies.set(key, (0, _base.encodeToBase64)(value), _objectSpread({
        serverSideCookieOptions: _api.serverSideCookieOptions
      }, additionalParams));
      return;
    })();
  }
  getItem(key) {
    var _this2 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      return (0, _base.decodeFromBase64)(_this2.cookies.get(key));
    })();
  }
  removeItem(key) {
    var _this3 = this;
    return (0, _asyncToGenerator2.default)(function* () {
      _this3.cookies.set(key, null);
      return;
    })();
  }
}
exports.CookieStorageServer = CookieStorageServer;